import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import UpdateDocumentHeaderForm from "../../forms/UpdateDocumentHeaderForm";

const UpdateDocumentHeaderModal = ({
  open,
  onClose,
  documentHeader,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Edit ${documentHeader?.documentType} Template`}
      width="md"
      loading={loading}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <UpdateDocumentHeaderForm
        documentHeader={documentHeader}
        loading={loading}
      />
    </AppModal>
  );
};

export default UpdateDocumentHeaderModal;
